<script lang="ts" setup>
    import { OffsetGroup } from '~/data/OffsetGroup'

    const { block } = defineProps<{
        block: MediaBlock
    }>()

    const offset = OffsetGroup.fromData(block)
</script>

<template>
    <div class="layout-grid block-gap-y">
        <div :class="offset.classes">
            <Asset :asset="block.asset" />
        </div>
    </div>
</template>
